module.exports = __webpack_public_path__ + "static/media/kudoss-logo2.da08e9f6.svg";